<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../../assets/images/zgxq1.png" class="steps step1" v-if="status==1">
			<img src="../../../assets/images/zgxq2.png" class="steps step2" v-if="status==2">
         <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--        <breadcrumb :routerList="[{to:'/credit',title:'经理销售维度'},{title:'资金详情'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece h-mrt30 width">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<div class="h-formBox w-formBox">
						<el-form-item label="客户名称">
							<el-input v-model="formInline.username" placeholder="模糊查询"></el-input>
						</el-form-item>
						<el-form-item label="客户编号">
							<el-input v-model="formInline.userCode" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="公司代码">
							<el-input v-model="formInline.companyCode" placeholder=""></el-input>
						</el-form-item>
<!--						<el-form-item label="区域类型">
							<el-select v-model="formInline.countrytype" placeholder="请选择">
							    <el-option label="国内" value="1"></el-option>
								<el-option label="海外" value="2"></el-option>
							</el-select>
						</el-form-item>-->
					</div>

				</el-form>
				<div class="l-screenBox">
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="selectData">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">
							重置
						</el-button>
						<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createCredit" v-if="isShowCreateCredit">
							新增信贷申请
						</el-button>
					</div>
				</div>
            </div>
            <div class="h-table" style="margin-top: 0.24rem;">
				<div>
					<div style="color: #ff0000;font-size: 14px;">1.总余额为正数表示截至目前贵司已提交的所有订单计算扣减后尚有结余金额，负数表示截至目前贵司已提交的订单计算后尚欠款的金额</div>
					<div style="color: #ff0000;font-size: 14px;">2.公司代码9390代表"青岛海尔生物医疗股份有限公司",9370代表"青岛海尔生物医疗科技有限公司", 1RK0代表"青岛海尔生物医疗设备有限公司",0PN0代表"海尔生物医疗科技(成都)有限公司",1R60代表"苏州康盛生物有限公司", 1D90 代表"海乐苗（青岛）智能物联有限公司"</div>
<!--          <div style="color: #ff0000;font-size: 14px;">3.总余额=现金余额+信贷余额-逾期欠款=信贷限额-风险总额-在途订单金额</div>-->
				</div>
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        stripe
						:cell-style="cellStyle"
                        style="width: 100%"
						:border="true"
						max-height="470"
                >
                    <!-- <el-table-column type="selection" width="40" label="全选"></el-table-column> -->
                    <el-table-column fixed type="index" label="#" width="40"></el-table-column>
                    <el-table-column prop="username" label="客户名称"  min-width="170"
                                     :show-overflow-tooltip="true">
									 <template slot-scope="scope">
									 	<div style="text-align: left;">
									 		{{scope.row.username}}
									 	</div>
									 </template>
									 </el-table-column>
                    <el-table-column prop="userCode" label="客户编号" width="120" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="companyCode" label="公司代码" width="80" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="currencyCode" label="币种" width="70" ></el-table-column>
          <el-table-column prop="zye" label="总余额" width="120" v-if="adminFlag" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.zye}}
							</div>
						</template>
					</el-table-column>
            <el-table-column prop="klimk" label="SAP限额" width="120"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <div style="text-align: right;">
                        {{scope.row.klimk}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column   prop="oblig"   label="SAP风险总额"  width="120" :show-overflow-tooltip="true" >
                <template slot-scope="scope">
                    <div style="text-align: right;">
                        {{scope.row.oblig}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column  prop="sapyue"  label="SAP余额"  width="90":show-overflow-tooltip="true"   >
                <template slot-scope="scope">
                    <div style="text-align: right;">
                        {{scope.row.sapyue}}
                    </div>
                </template>
            </el-table-column>


           <el-table-column prop="cashBalance" label="现金余额" width="120"  v-if="adminFlag" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.cashBalance}}
							</div>
						</template>
					</el-table-column>
                    <el-table-column prop="creditBalance" label="信贷余额"   v-if="adminFlag" width="120" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.creditBalance}}
							</div>
						</template>
					</el-table-column>
					<el-table-column style="border-right: 2px solid #ccc;" prop="owe" label="逾期欠款" width="100" v-if="adminFlag" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.owe}}
							</div>
						</template>
					</el-table-column>
            <el-table-column prop="xdxe" label="信贷限额" width="120" v-if="adminFlag"></el-table-column>
            <el-table-column prop="fxze" label="风险总额" width="120" v-if="adminFlag"></el-table-column>
            <el-table-column prop="ztze" label="在途订单总额" width="110" ></el-table-column>
                    <!-- <el-table-column prop="zye" label="总余额" width="120" ></el-table-column> -->
                    <!--<el-table-column prop="creCategory" label="信贷类型"  width="120" :show-overflow-tooltip="true">-->
                        <!--<template slot-scope="scope" >-->
                        <!--<dictname category="cre_category" :v="scope.row.creCategory" />-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column prop="payMentDate" label="信贷账期"  width="120"></el-table-column>-->
                    <!--<el-table-column prop="status" label="审核状态"  width="120">-->
                        <!--<template slot-scope="scope" >-->
                            <!--<dictname category="credit_status" :v="scope.row.status" />-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column prop="maxQuoTa" label="信贷申请额度"  width="130"></el-table-column>-->
<!--                    <el-table-column prop="creditBalance" label="信贷总额" :show-overflow-tooltip="true"></el-table-column>-->
<!--                    <el-table-column prop="isSign" label="是否有签字">-->
<!--                        <template slot-scope="scope">-->
<!--                            <dictname category="is_sign" :v="scope.row.isSign"/>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                        <template slot-scope="scope">-->
<!--                            <dictname category="is_overdue" :v="scope.row.isOverdue"/>-->
<!--                        </template>-->
<!--                    <el-table-column prop="paymentdate" label="中信保批复账期" :show-overflow-tooltip="true"></el-table-column>-->
                    <el-table-column label="操作" fixed="right" width="80">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
								<el-button
								        type="text"
								        size="small"
								        class="h-tableLink h-btn"
								        @click="seeDetail(scope.row)"
								>查看
								</el-button>
							</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <!--          <div class="h-tableBL">-->
                    <!--            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>-->
                    <!--             <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export">批量导入</el-button> -->
                    <!--          </div>-->
                    <div class="h-pagination2">
                        <pagination :page="q" @query="choose"/>
                    </div>
                </div>
            </div>
        </div>
		<el-dialog :close-on-click-modal="false" :visible.sync="newDialog" class="h-dialog2">
		    <div class="h-dialogImg">
		        <div class="h-disTable">
		            <div class="h-tableCell">
		                <h1>新增信贷</h1>
		                <p>New quota application</p>
		            </div>
		        </div>
		    </div>
            <div class="h-formLines">
                <div style="padding: 12px;" class="dialogout X-dai">
                    <el-form :model="dialogForm" label-position="right" ref="dialogForm" :rules="rules2" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine" style="margin-right:60px">
                                      <el-form-item label="信贷种类" class="h-elformWrap-2" prop="creCategory">
                                        <brselectlazy category="cre_category" :v="dialogForm.creCategory"
                                                      v-model="dialogForm.creCategory" :clearable="true"
                                                      style="width:2.2rem"/>
                                      </el-form-item>
                                      <el-form-item label="客户名称" class="h-elformWrap-2" prop="username">
                                        <el-select filterable v-model="value1" placeholder="请选择"
                                                   @change="isShowUpload">
                                          <el-option
                                              v-for="(item,index) in agentList"
                                              :key="index"
                                              :label="item.customerName1+'-'+item.usercode"
                                              :value="index">
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                        <!--<el-form-item label="信贷种类" class="h-elformWrap-2" prop="creCategory">-->
                                        <!--    <brselectlazy category="cre_category" :v="dialogForm.creCategory"-->
                                        <!--                  v-model="dialogForm.creCategory" :clearable="true"-->
                                        <!--                  style="width:2.2rem"/>-->
                                        <!--</el-form-item>-->
                                        <el-form-item label="专属产品大类" class="h-elformWrap-2" prop="productId"
                                                      v-if="dialogForm.creCategory == 0">
                                            <brselect category="product_level" :v="dialogForm.productId"
                                                          v-model="dialogForm.productId" :clearable="true"
                                                          style="width:1.7rem"/>
                                        </el-form-item>

                                        <el-form-item label="渠道" class="h-elformWrap-2" prop="ywType"
                                                      v-if="dialogForm.creCategory == 0 || dialogForm.creCategory == 2">
                                            <brselect category="cre_category_qd" :v="dialogForm.ywType"
                                                      v-model="dialogForm.ywType" :clearable="true"
                                                      style="width:1.7rem"/>
                                        </el-form-item>

                                        <el-form-item label="币种" class="h-elformWrap-2"  prop="currency">
                                            <brselect category="YLCurrency" :v="dialogForm.currency" @change="exchange"
                                                    v-model="dialogForm.currency" :clearable="true" />
                                        </el-form-item>
                                        <el-form-item label="申请金额" class="h-elformWrap-2" prop="maxquota">
                                            <el-input placeholder="请输入" v-model="dialogForm.maxquota" @change="exchange" ></el-input>
                                        </el-form-item>
                                        <el-form-item label="人民币金额" class="h-elformWrap-2" prop="rmbquota">
                                          <el-input placeholder="请输入" v-model="dialogForm.rmbquota"></el-input>
                                        </el-form-item>
                                        <el-form-item label="销售经理" class="h-elformWrap-2" prop="qdmanger" v-if="dialogForm.creCategory == 1">
                                          <el-input placeholder="请输入" v-model="dialogForm.qdmanger"></el-input>
                                        </el-form-item>
                                        <el-form-item label="省区经理" class="h-elformWrap-2" prop="qymanger" v-if="dialogForm.creCategory == 1">
                                          <el-input placeholder="请输入" v-model="dialogForm.qymanger"></el-input>
                                        </el-form-item>
                                        <el-form-item label="平台接口人" class="h-elformWrap-2" prop="ptjkr" v-if="dialogForm.creCategory == 1">
                                          <el-input placeholder="请输入" v-model="dialogForm.ptjkr"></el-input>
                                        </el-form-item>
                                        <el-form-item label="链群主" class="h-elformWrap-2" prop="lianqunzhu" v-if="dialogForm.creCategory == 1">
                                          <el-input placeholder="请输入" v-model="dialogForm.lianqunzhu"></el-input>
                                        </el-form-item>

                                        <el-form-item label="承诺回款时间" class="h-elformWrap-2" prop="validitydate"
                                                      v-if="this.agentType == '1'">
                                            <template>
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="dialogForm.validitydate"
                                                            type="date"
                                                            placeholder="--选择--"
                                                            >
                                                    </el-date-picker>
                                                </div>
                                            </template>
                                        </el-form-item>
                                        <el-form-item label="批复账期" class="h-elformWrap-2" prop="paymentdate"
                                                      v-if="this.agentType == '2'||this.agentType == '3'"
                                        >
                                            <el-input placeholder="请输入" type="number" v-model="dialogForm.paymentdate"></el-input>
                                            <span style="position:absolute;left:142px; font-size: 16px">天</span>

                                        </el-form-item>
                                        <el-form-item label="公司代码" class="h-elformWrap-2" prop="kkber">
                                            <brselectlazy category="kkber_domestic_value" :v="dialogForm.kkber"
                                                          v-model="dialogForm.kkber" :clearable="true"
                                                          v-show="this.accountGroup == '0210' || this.accountGroup == '0280'"
                                                          style="width:2.2rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap"/>
                                            <brselectlazy category="kkber_foreign_value" :v="dialogForm.kkber"
                                                          v-model="dialogForm.kkber" :clearable="true"
                                                          v-show="this.accountGroup == '0260'"
                                                          style="width:2.2rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap"/>
                                        </el-form-item>
                                        <el-form-item v-if="dialogForm.creCategory == 0 || dialogForm.creCategory == 2"  label="节点接口人" class="h-elformWrap-2" prop="jdjkr">
                                          <el-input placeholder="没有请填写无" v-model="dialogForm.jdjkr"></el-input>
                                        </el-form-item>
                                        <el-form-item v-if="dialogForm.creCategory == 1"  label="买方编码" class="h-elformWrap-2" prop="">
                                          <el-input placeholder="请输入" v-model="dialogForm.buyerCode"></el-input>
                                        </el-form-item>
                                         <el-form-item v-if="dialogForm.creCategory == 1"   label="买方名称" class="h-elformWrap-2" prop="">
                                          <el-input placeholder="请输入" v-model="dialogForm.buyerName"></el-input>
                                        </el-form-item>
                                      <el-form-item v-if="dialogForm.creCategory == 1"   label="中信保账期" class="h-elformWrap-2" prop="">
                                        <el-input placeholder="请输入" type="number" v-model="dialogForm.zxbPaymentDate"></el-input>
                                        <span style="position:absolute; font-size: 16px">天</span>
                                      </el-form-item>

                                        <el-form-item  v-if="this.agentType == 1" label="项目名称" class="h-elformWrap-1" prop="">
                                            <el-input placeholder="请输入" v-model="dialogForm.projectName"></el-input>
                                        </el-form-item>


                                        <el-form-item label="附件" class="h-elformWrap-2 pfpz" :prop="isShow ? 'upload' : ''">
                                            <brupload

                                                    :refid="refid"
                                                    reftype="信贷管理-新增信贷"
                                                    uploadflag
                                                    delflag
                                                    :showtime="false"
                                                    @filecallback=isUpload
                                            >
                                            </brupload>
                                            <el-dialog :visible.sync="dialogVisible">
                                                <img width="100%" :src="dialogImageUrl" alt="">
                                            </el-dialog>
                                        </el-form-item>
                                        <div>
                                            <div style="color: #ff0000;font-size: 16px;">
                                                <span v-if="this.agentType == '1'">提示：附件请上传签批完整的信贷申请（非中信保信贷）、框架合同补充协议或直单合同；以上必填项请市场节点人员审批。相关责任人对业务真实性负责，同意按照公司应收考核机制接受考核。
                                                </span>
                                                <span v-if="this.agentType == '2'||this.agentType == '3'">提示：附件请上传给中信保审批单，以上必填项与中信保客户信息保持一致
                                                </span>
                                            </div>
                                        </div>

										                    <el-form-item label="备注" class="h-elformWrap-1">
											                      <el-input type="textarea" v-model="dialogForm.signCompany" placeholder="请输入" class="h-txtareaBox" rows="4"></el-input>
										                    </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
<!--                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveCreate" v-show="isShowSaveCredit">暂存-->
<!--                    </el-button>-->
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate('dialogForm')">提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import supervisorDetailsService from "../../../api/loud/credit/supervisorDetailsService";
    import util from "../../../utils/util";
    import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
	import ss from '../../../api/SystemService';

    export default {
        data() {
            var validateNumber = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写必填项'));
                } else {
                    if (/^[0-9]+(\.?[0-9]+)?$/.test(this.dialogForm.maxquota)) {
                        callback();
                    } else {
                        callback(new Error('请输入数字或小数'));
                    }
                }
            };
            return {
				dialogVisible: false,
				dialogImageUrl:'',
                isShowCreateCredit : true,
                showOrhide:false,
                status:1,
                checked:true,
                toshow:"paodong1",
                agentType: '',
                agentType1: '',
                radio1: '临时解冻',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    },
                },
                freezeData:{
                    timeData:'',
                    creditId:'',
                },
                centerDialogVisible1: false,
                accountGroup: '',
                accountGroup1: '',
                value2: '',
                value22: '',
                value1: '',
                value11: '',
                agentList: [],
                getcustome:[],
                customerName11:'',
                usercode:'',
                value: {},
                value0: {},
                dialogForm: {
                    foreignCurrency: '',
                    username: '',
                    id: null,
                    maxquota: null,
					          rmbquota: null,
                    receDate: null,
                    isSign: '',
                    isOverdue: '',
                    signCompany: null,
                    cdate: null,
					          currency: null,
                    validitydate: null,
                    paymentdate: null,
                    kkber: null,
                    ctlpc: null,
                    creCategory: null,
                    ywType:null,
                    productId: null,
                    upload: null,
                    qdmanger:null,
                    qymanger: null,
                    ptjkr: null,
                    lianqunzhu: null,
                    buyerCode:null,
                    buyerName:null,
                    zxbPaymentDate:null,
                    projectName:null,
                },
                rules2: {
                    username: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    maxquota: [
                        {required: true, validator: validateNumber, trigger: 'blur'},
                    ],
					rmbquota: [
						{required: true, validator: validateNumber, trigger: 'blur'},
					],
					currency: [
						{required: true, message: '请填写必填项', trigger: 'blur'},
					],
                    receDate: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    isSign: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    isOverdue: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    signCompany: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    paymentdate: [
                        {required: true, validator: validateNumber, trigger: 'blur'},
                    ],
                    validitydate: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    creCategory: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    productId: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    ywType: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    kkber: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    jdjkr: [
                      {required: true, message: '请填写必填项,没有请填写无', trigger: 'blur'},
                    ],
                    ctlpc: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    upload: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                  buyerCode: [
                    {required: true, message: '请填写必填项', trigger: 'blur'},
                  ],
                  buyerName: [
                    {required: true, message: '请填写必填项', trigger: 'blur'},
                  ],
                  zxbPaymentDate: [
                    {required: true, message: '请填写必填项', trigger: 'blur'},
                  ],

                },
                isShowChart: false,
                zy: {
                    khmc: '',
                    xdzh: '',
                    hfkzfw: '',
                    bz: ''
                },
                //表单
                formInline: {
                    area: '',
                    username: null,
                    userCode: null,
                    companyCode: null,
                    countrytype:'', //默认国内屏蔽国外
                    pageSize: 10,
                    pageNo: 1,
                },
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表格
                multipleSelection: [],
                tableData: [],
                userData: {},
                viewUserCredit: {
                    region: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                ischeck: false,
                viewMoneyCash: {
                    area: null,
                    cashBalance: 0,
                    creditBalance: 0,
                    tocash: 0,
                    cashed: 0,
                    isOverdue: 0,
                    isNotOverdue: 0,
                    isGoingOverdue: 0,
                },
                res: {},
                isShowSaveCredit: null,
                newDialog: false,
                refid: null,
                isShow: false,
                shengjiFlag :false,//判断是否审计
                adminFlag:false,//判断是管理员
            };
        },
        created() {
			      // 遮罩
			      this.showzhezhao()
            //获取当前登录用户所属地区和对应经销商信贷列表
            this.getUserAreaAndCreditList();
            //审计
            this.shengjiFlag = this.$store.getters.hasRole('suoyouliebiaochakan');

            //是否管理员权限
            this.adminFlag = this.$store.getters.hasRole('swyl_admin');

        },
        methods: {
			cellStyle({row, column, rowIndex, columnIndex}){
				if(columnIndex === 7){//指定列号
					return 'border-right: 2px solid #6d8fa3;'
				}else{
					return ''
				}
			},
            exchange(){
				if(this.dialogForm.maxquota && this.dialogForm.currency){
					customerDetailsService.exchange(this.dialogForm.maxquota,this.dialogForm.currency).then(res => {
						this.dialogForm.rmbquota = res;
					})
				}
            },
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            timeSelect() {
                this.formInline.startReleaseDate = this.value2[0];
                this.formInline.endReleaseDate = this.value2[1];
            },
            isUpload(v) {
                if (v.length > 0) {
                    this.dialogForm.upload = 1;
                }
            },
            isShowUpload(v) {
                if (this.agentList[v].agentType == '1'){
                    this.isShow = true;
                }else {
                    this.isShow = false;
                }
                this.value = this.agentList[v];
                this.agentType = this.agentList[v].agentType;
                this.accountGroup = this.agentList[v].accountGroup;
                this.refid = this.value.usercode + "新增信贷临时refid";
                this.dialogForm.username = this.value.customerName1;
                this.dialogForm.usercode = this.value.usercode;
            },
            //取消按钮
            exit() {
                this.isShow = false;
                this.newDialog = false;
            },
            //提交审核新增信贷信息
            commitCreate(form) {
                if((this.agentType == '2' || this.agentType == '3') && this.dialogForm.creCategory == 1){
                    if(!this.dialogForm.buyerCode){
                         this.$msg.msge("外销客户中信保信贷 买方编码不能为空")
                         return;
                    }
                    if(!this.dialogForm.buyerName){
                        this.$msg.msge("外销客户中信保信贷 买方名称不能为空")
                        return;
                    }
                    if(!this.dialogForm.zxbPaymentDate){
                        this.$msg.msge("外销客户中信保信贷 中信保账期不能为空")
                        return;
                    }
                }
                if(this.agentType == '1' && this.dialogForm.creCategory == 1){
                    if(!this.dialogForm.ptjkr){
                        this.$msg.msge("内销客户 平台接口人不能为空")
                        return;
                    }
                    if(!this.dialogForm.qdmanger){
                        this.$msg.msge("内销客户 销售经理不能为空")
                        return;
                    }
                    if(!this.dialogForm.qymanger){
                        this.$msg.msge("内销客户 省区经理不能为空")
                        return;
                    }
                    if(!this.dialogForm.lianqunzhu){
                        this.$msg.msge("内销客户 链群主不能为空")
                        return;
                    }
                }
                this.$refs[form].validate((valid) => {
                    if (valid) {

                        if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.receDate))) {
                            if (this.dialogForm.receDate !== null) {
                                this.dialogForm.receDate = util.riQi3(this.dialogForm.receDate);
                            }
                        }
                        if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.cdate))) {
                            if (this.dialogForm.cdate !== null) {
                                this.dialogForm.cdate = util.riQi3(this.dialogForm.cdate);
                            }
                        }
                        if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.validitydate))) {
                            if (this.dialogForm.validitydate !== null) {
                                this.dialogForm.validitydate = util.riQi3(this.dialogForm.validitydate);
                            }
                        }
                        this.dialogForm.refidUserCode = this.value.usercode;
                        customerDetailsService.commitCreate(this.dialogForm).then(response => {
                            console.log(response, '提交审核新增信贷信息返回结果');
                            if (response.f) {
                                this.$message({
                                    type: "success",
                                    message: response.msg
                                });
                                this.queryCreditList();
                                this.newDialog = false;
                                this.isShow = false;
                            } else {
                                this.$message({
                                    type: "error",
                                    message: response.msg
                                });
                                this.isShow = false;
                            }

                        })
                    } else {
                        return false;
                    }
                });
            },
            //暂存新增信贷信息
            saveCreate() {
                this.isShow = false;
                this.dialogForm.status = 2;
                this.dialogForm.usercode = this.value.usercode;
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.receDate))) {
                    if (this.dialogForm.receDate !== null) {
                        this.dialogForm.receDate = util.riQi3(this.dialogForm.receDate);
                    }
                }
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.cdate))) {
                    if (this.dialogForm.cdate !== null) {
                        this.dialogForm.cdate = util.riQi3(this.dialogForm.cdate);
                    }
                }
                if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.dialogForm.validitydate))) {
                    if (this.dialogForm.validitydate !== null) {
                        this.dialogForm.validitydate = util.riQi3(this.dialogForm.validitydate);
                    }
                }
                this.dialogForm.refidUserCode = this.value.usercode;
                customerDetailsService.saveCreate(this.dialogForm).then(response => {
                    console.log(response, '暂存新增信贷信息返回结果')
                    if (response.f) {
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                        this.newDialog = false;
                    }
                })
            },
            createCredit() {
                this.$nextTick(() => {
                    this.value1 = '';
                    this.dialogForm.maxquota = null;
                    this.dialogForm.receDate = null;
                    this.dialogForm.isSign = null;
                    this.dialogForm.isOverdue = null;
                    this.dialogForm.signCompany = null;
                    this.dialogForm.cdate = null;
                    this.dialogForm.validitydate = null;
                    this.dialogForm.paymentdate = null;
                    this.dialogForm.kkber = null;
                    this.dialogForm.ctlpc = null;
                    this.dialogForm.creCategory = null;
                    this.dialogForm.productId = null;
                    this.$refs["dialogForm"].resetFields();
                });
                this.isShowSaveCredit = true;
                this.newDialog = true;
                //加载上传插件
                // this.refid = this.user.usercode + '新增信贷临时refid';
                // this.isShow = true;
            },
            //查询主管区域内经销商金额和返利列表
            selectMoneyCashList() {
                console.log(this.viewUserCredit, 'aaaaaaaaaaaaaaaaaaaaaaa')
                supervisorDetailsService.selectMoneyCashList(this.viewUserCredit).then(response => {
                    console.log(response, '查询主管区域内经销商金额和返利列表')
                    this.res = response;
                    // console.log(this.res,"++++++++++++++++++");
                    // for (var i=0;i<this.res.length;i++){
                    //     this.viewMoneyCash.cashBalance +=this.res[i].cashBalance;
                    //     this.viewMoneyCash.creditBalance += this.res[i].creditBalance;
                    //     this.viewMoneyCash.tocash += this.res[i].tocash;
                    //     this.viewMoneyCash.cashed += this.res[i].cashed;
                    //     if (this.res[i].isOverdue==='1'){
                    //         this.viewMoneyCash.isOverdue += 1;
                    //     }else if (this.res[i].isOverdue==='2'){
                    //         this.viewMoneyCash.isNotOverdue += 1;
                    //     }else if (this.res[i].isOverdue==='3'){
                    //         this.viewMoneyCash.isGoingOverdue += 1;
                    //     }
                    // }
                    // console.log(this.viewMoneyCash,'viewMoneyCash')
                    // console.log(this.res,'res')
                    this.lineChart1();
                    this.lineChart2();
                    this.lineChart3();
                    this.isShowChart = true;
                })
            },
            //检索按钮功能
            selectData() {

                this.ischeck = true;
                this.formInline.pageNo = 1;
                this.formInline.pageSize = 10;
                // if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.startReleaseDate))) {
                //     if (this.formInline.startReleaseDate !== null) {
                //         this.formInline.startReleaseDate = util.riQi3(this.formInline.startReleaseDate);
                //     }
                // }
                // if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.endReleaseDate))) {
                //     if (this.formInline.endReleaseDate !== null) {
                //         this.formInline.endReleaseDate = util.riQi3(this.formInline.endReleaseDate);
                //     }
                // }
                supervisorDetailsService.getCreditList(this.formInline).then(response => {
                    console.log(response, '检索结果')
                    this.tableData = response.records;
                    this.q.total = response.total;
                })
            },
            selectDataPage() {
                this.ischeck = true;
                // if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.startValiditydate))) {
                //     if (this.formInline.startValiditydate !== null) {
                //         this.formInline.startValiditydate = util.riQi3(this.formInline.startValiditydate);
                //     }
                // }
                // if (!(/^\d{4}\-\d{2}\-\d{2}$/.test(this.formInline.endValiditydate))) {
                //     if (this.formInline.endValiditydate !== null) {
                //         this.formInline.endValiditydate = util.riQi3(this.formInline.endValiditydate);
                //     }
                // }
                console.log(this.formInline,'检索输入项')
                supervisorDetailsService.getCreditList(this.formInline).then(response => {
                    console.log(response, '检索结果')
                    this.tableData = response.records;
                    this.q.total = response.total;
                })
            },
            //重置按钮功能
            resectData() {
                this.value2 = '';
                this.formInline.username = null;
                this.formInline.userCode = null;
                this.formInline.companyCode = null;
				this.formInline.countrytype = '';
            },
            //查看详情按钮功能
            seeDetail(v) {
				var url = this.$router.resolve({path: '/customerDetails',
					query:{usercode: v.userCode, username: v.username, countrytype: v.countrytype, companyCode: v.companyCode}});
				window.open(url.href, "_blank");
            },
            //分页功能查询选择
            choose() {
                if (this.ischeck) {
                    this.formInline.pageNo = this.q.pageNo;
                    this.formInline.pageSize = this.q.pageSize;
                    this.selectDataPage();
                } else {
                    this.queryCreditList();
                }
            },
            //查询地区对应经销商信贷列表
            queryCreditList() {
                this.viewUserCredit.pageNo = this.q.pageNo;
                this.viewUserCredit.pageSize = this.q.pageSize;
                supervisorDetailsService.getCreditList(this.viewUserCredit).then(response => {
                    console.log(response, '获取登录用户所属地区对应经销商信贷列表');
                    this.tableData = response.records;
                    this.q.total = response.total;
                })
            },
            //获取当前登录用户所属地区和对应经销商信贷列表
            getUserAreaAndCreditList() {
			    // 判断当前用户是否是经销商
                supervisorDetailsService.isDailishang().then(res => {
                    if (res){
                        this.isShowCreateCredit = false;
                    }else {
                        supervisorDetailsService.getAgentList().then(res => {
                            this.agentList = res;
                        })
                    }
                })
                supervisorDetailsService.getUser().then(response => {
                    console.log(response, '获取当前登录用户');
                    this.userData = response.obj;
                    this.viewUserCredit.area = response.obj.area;
                    this.formInline.area = response.obj.area;
                    this.viewMoneyCash.area = response.obj.area;
                    // console.log(this.$getters.user.usercode,'aaaaaaaaaaaaaaaaaaaadfasdfasdfafd')
                    // if (this.$getters.user.usercode != 'A0001668'){
                        this.selectMoneyCashList();
                    // }



                    supervisorDetailsService.getCreditList(this.viewUserCredit).then(response => {
                        console.log(response, '获取登录用户所属地区对应经销商信贷列表');
                        this.tableData = response.records;
                        this.q.total = response.total;
                    })
                })
            },
            lineChart1() {

                let lineChart1 = this.$echarts.init(document.getElementById('h_lineChart1'));
                let option = {
                    title: {
                        text: '余额报表',
                        bottom: '25%',
                        left: 'center',
                        textVerticalAlign: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom: "5%",
                        data: ['信贷：￥' + this.res.creditBalance, '现金：￥' + this.res.cashBalance]
                    },
                    series: [
                        {
                            name: '余额报表',
                            type: 'pie',
                            radius: '35%',
                            center: ['50%', '35%'],
                            data: [
                                {value: this.res.creditBalance, name: '信贷：￥' + this.res.creditBalance, selected: true},
                                {value: this.res.cashBalance, name: '现金：￥' + this.res.cashBalance}
                            ],
                            label: {
                                normal: {
                                    show: true,
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: true,
                                    length: 5,
                                    length2: 5
                                }
                            },
                            hoverOffset: 10,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                color: function (params) {
                                    //自定义颜色
                                    var colorList = [
                                        '#afe6fd', '#5ba9fe'
                                    ];
                                    return colorList[params.dataIndex]
                                }
                            }
                        }
                    ]
                };
                lineChart1.setOption(option);
            },
            lineChart2() {
                let lineChart2 = this.$echarts.init(document.getElementById('h_lineChart2'));
                let option = {
                    title: {
                        text: '信贷报表',
                        bottom: '25%',
                        left: 'center',
                        textVerticalAlign: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom: "2%",
                        data: ['正常：' + this.res.isNotOverdue, '逾期预警：' + this.res.isGoingOverdue, '已逾期：' + this.res.isOverdue]
                    },
                    series: [
                        {
                            name: '信贷报表',
                            type: 'pie',
                            radius: '35%',
                            center: ['50%', '35%'],
                            data: [
                                {value: this.res.isNotOverdue, name: '正常：' + this.res.isNotOverdue, selected: true},
                                {value: this.res.isGoingOverdue, name: '逾期预警：' + this.res.isGoingOverdue},
                                {value: this.res.isOverdue, name: '已逾期：' + this.res.isOverdue}
                            ],
                            label: {
                                normal: {
                                    show: true,
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: true,
                                    length: 5,
                                    length2: 5
                                }
                            },
                            hoverOffset: 10,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                color: function (params) {
                                    //自定义颜色
                                    var colorList = [
                                        '#1c86ff', '#afe6fd', '#5ba9fe'
                                    ];
                                    return colorList[params.dataIndex]
                                }
                            }
                        }
                    ]
                };
                lineChart2.setOption(option);
            },
            lineChart3() {
                let lineChart3 = this.$echarts.init(document.getElementById('h_lineChart3'));
                let option = {
                    title: {
                        text: '返利报表',
                        bottom: '25%',
                        left: 'center',
                        textVerticalAlign: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        bottom: "5%",
                        data: ['已兑：￥' + this.res.cashed, '未兑：￥' + this.res.tocash]
                    },
                    series: [
                        {
                            name: '返利报表',
                            type: 'pie',
                            radius: '35%',
                            center: ['50%', '35%'],
                            data: [
                                {value: this.res.cashed, name: '已兑：￥' + this.res.cashed, selected: true},
                                {value: this.res.tocash, name: '未兑：￥' + this.res.tocash}
                            ],
                            label: {
                                normal: {
                                    show: true,
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: true,
                                    length: 5,
                                    length2: 5
                                }
                            },
                            hoverOffset: 10,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                color: function (params) {
                                    //自定义颜色
                                    var colorList = [
                                        '#afe6fd', '#5ba9fe'
                                    ];
                                    return colorList[params.dataIndex]
                                }
                            }
                        }
                    ]
                };
                lineChart3.setOption(option);
            },
            closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
				if(this.status ==1){
						this.status = 2;
				}else if(this.status ==2){
					if(this.checked){
                      ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                      	console.log(rd)
                      	this.showOrhide = false;
                      })
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			}
        },
        mounted() {

        }
    };
</script>

<style>
    .width .el-form-item__label {
        vertical-align: top;
    }

    .width .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 7px;
    }

    .X-dai .h-formbLine .h-elformWrap-2 {
        padding-right: 0.5rem;
        width: 50% !important;
    }
	.X-dai .h-formbLine .h-elformWrap-1 {
	    padding-right: 0;
	    width: 100% !important;
	}
	.X-dai .h-formbLine .h-elformWrap-1 .el-form-item__label{
	    width: 22%;
	}
	.X-dai .h-formbLine .h-elformWrap-1 .el-form-item__content{
	    width: 78%;
	}
    .X-dai .h-formbLine .el-form-item__label {
        width: 51%;

    }
    .X-dai .h-formbLine .el-form-item__content {
        width: 49%;
    }

</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 6.55rem;
			left: 2.75rem;
			width:10.8rem;
			height: 1.7rem;
		}
		.step2{
			top: 6.5rem;
			right: 2.4rem;
			width: 2.6rem;
			height: 1.8rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
